import { FC, useEffect, useState } from 'react';
import LottieWrapper from './LottieWrapper';
import { ENV_CONFIG } from 'config/environment';
import { defaultOptions } from './commonOptions';
import * as animationNumber1 from 'assets/json/number1.json';
import * as animationNumber2 from 'assets/json/number2.json';
import * as animationNumber3 from 'assets/json/number3.json';

const FALLBACK_ANIMATIONS = {
  1: animationNumber1,
  2: animationNumber2,
  3: animationNumber3,
} as const;

interface Props {
  number: number;
}

const AboutOathNumber: FC<Props> = ({ number }) => {
  const [animationData, setAnimationData] = useState<any>(null);

  useEffect(() => {
    // Fetch the JSON file from the URL
    const fetchAnimationData = async () => {
      try {
        const response = await fetch(
          `${ENV_CONFIG().CLOUD_STORAGE.URL}/json/static_pages/number${number}.json`
        );
        const jsonData = await response.json();
        setAnimationData(jsonData);
      } catch (error) {
        const fallbackAnimation = FALLBACK_ANIMATIONS[number as keyof typeof FALLBACK_ANIMATIONS];
        if (fallbackAnimation) {
          setAnimationData(fallbackAnimation);
        }
      }
    };

    fetchAnimationData();
  }, []);

  return (
    <div className="orbs-number-wrapper">
      <div className="orbs-blurred-background radius40" />
      {animationData && (
        <LottieWrapper
          options={defaultOptions(animationData, 'radius40')}
          style={{ position: 'absolute' }}
          isClickToPauseDisabled={true}
        />
      )}
      <span className="h4-text color-white orbs-children orbs-number-children">{number}</span>
    </div>
  );
};

export default AboutOathNumber;
